import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import moment from 'moment'
export default {
  props: {
    title: String,
    serviceOrderId: Number,
    service: Object,
    disabled: Boolean,
    attendDateTime: Date,
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.service) {
      this.currentService = this.service
      this.splitTimeSpent(this.service.timeSpent)
      this.startStepDateTime = this.service.dateTimeStartStep
      this.endStepDateTime = this.service.dateTimeEndStep

      this.currentService.status =
        this.statusStep[this.service.statusStepServiceOrder]
      this.user = this.service.userResponsible

      if (this.service.alertDate) {
        this.alert = true
        this.alertDate = this.service.alertDate
      }

      this.isEditing = true
    }
    await this.getUsers()

    this.userName = this.user.id ? this.user.name : this.userLogged.name
  },

  data: () => ({
    institution: {},
    alertDate: null,
    alert: false,
    step: 0,
    selectedStartTab: 0,
    selectedEndTab: 0,
    errorMessage: '',
    isEditing: false,
    loading: false,
    firstValid: false,
    error: false,
    dialog: false,
    startStepDateTimeError: false,
    userName: null,
    startStepDateTime: null,
    endStepDateTime: null,
    timeCalculation: false,
    userLogged: {},
    institution: {},
    user: {},
    currentService: {
      id: 0,
      description: '',
      dateTimeStartStep: null,
      dateTimeEndStep: null,
      timeSpent: null,
      status: null,
      isMainStep: false,
    },
    statusStep: [
      'Manutenção terceirizada in loco',
      'Manutenção terceirizada externa',
      'Manutenção interna',
      'Aguardando peça',
      'Aguardando orçamento',
      'Aguardando avaliação externa',
      'Aguardando aprovação de orçamento',
      'Aguardando liberação do setor',
      'Deslocamento',
      'Equipamento não encontrado',
      'Aguardando Solicitação/Ordem de Compra',
    ],
    responsibleUsers: [],
    hoursRules: [
      (v) => v == null || v === '' || /^\d{1,6}$/.test(v) || 'Horas inválidas',
    ],
    minutesRules: [
      (v) =>
        v == null ||
        v === '' ||
        (/^\d{1,2}$/.test(v) && Number(v) <= 59) ||
        'Minutos inválidos (0-59)',
    ],
    timeSpentHours: '',
    timeSpentMinutes: '',
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    async getUsers() {
      await this.apiService
        .get(`user/allInst/${this.institutionId}`, true, false)
        .then((response) => {
          this.responsibleUsers = response.content.filter(
            (x) =>
              x.userType < 4 ||
              x.userType === 8 ||
              (this.user && x.name == this.user.name) ||
              x.name == this.userName ||
              x.id == this.userLogged.id
          )

          if (this.userLogged.mainType == 1) {
            this.responsibleUsers = this.responsibleUsers.filter(
              (x) =>
                x.userType > 1 ||
                (this.user && x.name == this.user.name) ||
                x.name == this.userName ||
                x.id == this.userLogged.id
            )
          }

          if (this.institution.userType == 2) {
            this.responsibleUsers = this.responsibleUsers.filter(
              (x) =>
                (x.userType > 2 && x.userType != 8) ||
                (this.user && x.name == this.user.name) ||
                x.name == this.userName ||
                x.id == this.userLogged.id
            )
          }
        })
    },

    close() {
      this.$emit('close')
    },

    validateDates() {
      if (
        !!this.startStepDateTime &&
        !!this.endStepDateTime &&
        moment(this.startStepDateTime).isAfter(moment(this.endStepDateTime))
      ) {
        this.$toast.warning(
          this.$t('A data de fim não pode ser antes da data de início')
        )
        return false
      }

      // Validar que a data de início da etapa não seja anterior à data de atendimento da O.S.
      if (
        !!this.startStepDateTime &&
        !!this.attendDateTime &&
        moment(this.startStepDateTime).isBefore(moment(this.attendDateTime))
      ) {
        this.$toast.warning(
          this.$t(
            'A data de início da etapa não pode ser anterior à "Data e Hora de Atendimento" da ordem de serviço'
          )
        )
        return false
      }

      return true
    },

    async next() {
      if (this.step === 0) {
        if (
          this.$refs.firstForm.validate() &&
          this.startStepDateTime &&
          this.validateDates()
        ) {
          this.submit()
        } else {
          this.startStepDateTimeError = true
        }
      } else {
        this.$emit('confirm')
      }
    },

    setStartStepNowDate() {
      this.startStepDateTime = !this.startStepDateTime
        ? new Date()
        : this.startStepDateTime
    },

    setEndStepNowDate() {
      this.endStepDateTime = !this.endStepDateTime
        ? new Date()
        : this.endStepDateTime
    },

    setAlertDateNowDate() {
      this.alertDate = !this.alertDate ? new Date() : this.alertDate
    },

    async submit() {
      this.loading = true

      const user = this.responsibleUsers.find((x) => x.name == this.userName)

      const userId = user ? user.id : this.user.id

      const service = {
        Id: this.currentService.id,
        UserResponsibleId: userId,
        Description: this.currentService.description,
        DateTimeStartStep: Utils.nowDatetimeFormat(this.startStepDateTime),
        DateTimeEndStep: Utils.nowDatetimeFormat(this.endStepDateTime),
        TimeSpent: this.joinTimeSpent(),
        StatusStepServiceOrder: this.statusStep.indexOf(
          this.currentService.status
        ),
        ServiceOrderId: this.serviceOrderId,
        alertDate: Utils.nowDatetimeFormat(this.alertDate),
        isMainStep: this.currentService.isMainStep,
      }

      let url = 'service/add'

      if (this.isEditing) {
        url = 'service/edit'
      }

      if (!this.alert) {
        service.alertDate = null
      }

      await this.apiService
        .post(url, service)
        .then(() => {
          if (
            service.StatusStepServiceOrder == 0 ||
            service.StatusStepServiceOrder == 1 ||
            service.StatusStepServiceOrder == 5
          ) {
            this.$emit('setExternal')
          }
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    onlyDigits(value, maxLength) {
      return String(value ?? '')
        .replace(/\D/g, '')
        .slice(0, maxLength)
    },

    // Minuto tem teto fixo de 59, sem a ambiguidade que existia no campo
    // único: aqui os dígitos nunca podem virar hora.
    clampMinutes(value) {
      const digits = this.onlyDigits(value, 2)

      if (digits === '') {
        return digits
      }

      return String(Math.min(Number(digits), 59))
    },

    padMinutes(value) {
      return value === '' || value == null
        ? value
        : String(value).padStart(2, '0')
    },

    // Divide o "HH:MM" vindo da API nos dois campos. Não trunca as horas: um
    // valor legado acima do limite reprova em hoursRules e trava o salvamento,
    // em vez de ser gravado de volta menor do que era.
    splitTimeSpent(value) {
      const match = /^(\d+):(\d{1,2})/.exec(String(value ?? '').trim())

      if (!match) {
        this.timeSpentHours = ''
        this.timeSpentMinutes = ''
        return
      }

      this.timeSpentHours = String(Number(match[1]))
      this.timeSpentMinutes = this.padMinutes(
        String(Math.min(Number(match[2]), 59))
      )
    },

    // Junta os dois campos no formato HH:MM que o backend armazena.
    joinTimeSpent() {
      if (this.timeSpentHours === '' && this.timeSpentMinutes === '') {
        return null
      }

      const hours = String(this.timeSpentHours || '0').padStart(2, '0')

      return `${hours}:${this.padMinutes(this.timeSpentMinutes || '0')}`
    },

    calculateTimeSpent() {
      if (
        this.timeCalculation &&
        this.startStepDateTime &&
        this.endStepDateTime
      ) {
        const start = moment(this.startStepDateTime)
        const end = moment(this.endStepDateTime)

        if (!start.isValid() || !end.isValid()) {
          return
        }

        const diffInMinutes = end.diff(start, 'minutes')
        if (diffInMinutes < 0) {
          return
        }

        const hours = Math.floor(diffInMinutes / 60)
        const minutes = diffInMinutes % 60

        this.timeSpentHours = String(hours)
        this.timeSpentMinutes = this.padMinutes(String(minutes))
      }
    },

    getInstitution() {
      this.instLoading = true

      this.apiService
        .get(`institution/${this.institutionId}`)
        .then((response) => {
          this.institution = response.content
          this.instLoading = false
        })
        .catch(() => {
          this.instLoading = false
        })
    },
  },

  watch: {
    alert(nv) {
      console.log(this.institution)
      if (nv) {
        switch (this.currentService.status) {
          case 'Manutenção terceirizada in loco':
            if (this.institution.onsiteOutsourcedMaintenance) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.onsiteOutsourcedMaintenance, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Manutenção terceirizada externa':
            if (this.institution.waitingExternalMaintenance) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waitingExternalMaintenance, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Manutenção interna':
            if (this.institution.internalMaintenance) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.internalMaintenance, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando peça':
            if (this.institution.waintingForPart) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingForPart, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando orçamento':
            if (this.institution.waintingBudget) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingBudget, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando avaliação externa':
            if (this.institution.waintingExternalAppraisal) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingExternalAppraisal, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando aprovação de orçamento':
            if (this.institution.waintingBudgetApproval) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waintingBudgetApproval, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Aguardando liberação do setor':
            if (this.institution.waitingDepartmentRelease) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.waitingDepartmentRelease, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          case 'Deslocamento':
            if (this.institution.displacement) {
              const date = new Date(
                moment(this.startStepDateTime)
                  .add(this.institution.displacement, 'days')
                  .format('yyyy-MM-DD 08:00')
              )
              this.alertDate = this.alertDate ? this.alertDate : date
            }
            break
          default:
            break
        }
      }
    },

    startStepDateTime: {
      deep: true,
      handler() {
        this.startStepDateTimeError = false
        this.calculateTimeSpent()
      },
    },

    endStepDateTime: {
      deep: true,
      handler() {
        this.calculateTimeSpent()
      },
    },

    timeCalculation(nv) {
      if (nv) {
        this.calculateTimeSpent()
      }
    },
  },
}
